interface ButtonColors {
  INACTIVE_CLASS: string;
  HOVER_CLASS: string;
  ACTIVE_CLASS: string;
}

const ButtonColorClasses: { [name: string]: ButtonColors } = {
  default: {
    INACTIVE_CLASS: 'T-I-ax7',
    HOVER_CLASS: 'T-I-JW',
    ACTIVE_CLASS: 'T-I-Kq',
  },

  flatIcon: {
    INACTIVE_CLASS: 'J-Z-I',
    HOVER_CLASS: 'J-Z-I-JW',
    ACTIVE_CLASS: 'J-Z-I-KO',
  },

  pureIcon: {
    INACTIVE_CLASS: 'inboxsdk__button_pureIcon_inactive',
    HOVER_CLASS: 'inboxsdk__button_pureIcon_hover',
    ACTIVE_CLASS: 'inboxsdk__button_pureIcon_active',
  },

  blue: {
    INACTIVE_CLASS: 'T-I-atl',
    HOVER_CLASS: 'T-I-JW',
    ACTIVE_CLASS: 'T-I-JO',
  },

  red: {
    INACTIVE_CLASS: 'T-I-KE',
    HOVER_CLASS: 'T-I-JW',
    ACTIVE_CLASS: 'T-I-JO',
  },

  green: {
    INACTIVE_CLASS: 'inboxsdk__button_green_inactive',
    HOVER_CLASS: 'inboxsdk__button_green_hover',
    ACTIVE_CLASS: 'inboxsdk__button_green_active',
  },

  outline: {
    INACTIVE_CLASS: 'ams',
    HOVER_CLASS: 'ams',
    ACTIVE_CLASS: 'ams',
  },
};

export default ButtonColorClasses;
